module.exports = __webpack_public_path__ + "media/Video 105.36c66e63.mp4";